import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_menu_gift_store",
  "use": "icon_menu_gift_store-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_menu_gift_store\"><path d=\"M8.749 8.26V7.6H2.875l.375-.659L9 6.4l1-3.6H2.313L1.873 1H0v.6h1.376l1.312 5.04-.815 1.561v.9c0 .48.44.899.94.899.498 0 .937-.42.937-.9 0-.48-.44-.899-.936-.899H7.5v.9c0 .48.436.899.937.899.5 0 .936-.42.936-.9 0-.421-.25-.72-.625-.84\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol